import React from 'react';
import Header from '../components/header';
import BreadCrumbsBar from '../components/breadCrumbsBar';
import Footer from '../components/footer';
import Hardware from '../components/hardware';
function HardwarePage() {
    return (
      <div>
        <Header />
        <BreadCrumbsBar />
        <Hardware />
        <Footer />
      </div>
    );
  }

 export default HardwarePage; 
  
  